import DraftListingFields from './DraftListingFields.component';

export default DraftListingFields;
